import { render, staticRenderFns } from "./AllegatiTable.vue?vue&type=template&id=4541a3fb&"
import script from "./AllegatiTable.vue?vue&type=script&lang=js&"
export * from "./AllegatiTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AllegatiTable.vue"
export default component.exports